var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list",class:{list: _vm.isLastInList(), final: !_vm.isLastInList()},style:(_vm.cssProps())})
}
var staticRenderFns = []

export { render, staticRenderFns }